import { Theme } from "@mui/material";
import { isSameDay } from "date-fns";
import { CONTENT_TYPE, LEVEL } from "../../consts";
import i18n from "../../services/i18n";
import type { CalendarLearningObject, ContentType, Level } from "../../types";
import { calendarTimeAsDateTime } from "../../utils/calendar";

// @ts-ignore
export const goToDetail = (dateObject: CalendarLearningObject, navigate, type?: string) => {
  const startTime = (dateObject.startDateTime) ?
    new Date(dateObject.startDateTime).toISOString() :
    calendarTimeAsDateTime({ date: dateObject.date ?? [9999, 12, 31], time: dateObject.startTime }).toISOString();
  const endTime = (dateObject.endDateTime) ?
    new Date(dateObject.endDateTime).toISOString() :
    calendarTimeAsDateTime({ date: dateObject.date ?? [9999, 12, 31], time: dateObject.endTime }).toISOString();
  switch (type) {
  case "smartLearning":
    console.log("[SMART-LEARNING]");
    navigate(`/smart-learning?endTime=${endTime}&startTime=${startTime}`);
    break;

  default:
    navigate(navigate.getDetailLink({
      id: dateObject.id,
      learningObjectTypology: dateObject.learningObjectTypology
    }));
    break;
  }
};

export function courseColor(dateObject: CalendarLearningObject, theme: Theme): string {
  if (
    dateObject?.dateObjectType !== "smartLearning" &&
    dateObject?.isMandatory
    && (
      dateObject.learningObjectType == "ASYNC"
      || dateObject.learningObjectType == "BLENDED"
    )
    && isSameDay(
      new Date(),
      new Date(dateObject.expirationDate.join("/"))
    )
  ) {
    return theme.customColors.textWarning;
  }
  return theme.customColors.systemSecondary01;
}


export function handleType(
  learningObjectType: ContentType,
  learningObjectTypology?: Level
) {
  if (learningObjectType === CONTENT_TYPE.ASYNC) {
    return i18n.t("digital");
  } else if (learningObjectType === CONTENT_TYPE.BLENDED) {
    return i18n.t("blended");
  } else if (learningObjectTypology === LEVEL.DA_PHYSICAL_CLASS) {
    return i18n.t("live_classroom");
  } else if (learningObjectTypology === LEVEL.DA_VIRTUAL_CLASS) {
    return i18n.t("virtual_classroom");
  } else if (learningObjectType === CONTENT_TYPE.SMART_LEARNING_SLOT) {
    return i18n.t("smart_learning");
  } else {
    return i18n.t("live");
  }
}


export const expiringLabel = (type:Level | "SMART_LEARNING_SLOT") => {
  if(type !== LEVEL.DA_PHYSICAL_CLASS && type !== LEVEL.DA_VIRTUAL_CLASS && type !== CONTENT_TYPE.SMART_LEARNING_SLOT){
    return `${i18n.t("expiring")} - `;
  }
  return "";
};

export const isTodayAssertion = (date: number) => {
  const startDate = new Date(date);
  return isSameDay(startDate, new Date());
};

export function isBeforeTodayAt0001(timestampMs: number): boolean {
  const now = new Date();

  const today0001 = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    0,   // ore
    0,   // minuti
    1,   // secondi
    0    // ms
  );

  return timestampMs < today0001.getTime();
}

export const ATTRIBUTE_TRANSLATION_MAP: Record<string, string> = {
  suggestedByHR: "HR_SUGGESTED",
  suggestedByManager: "MANAGER_SUGGESTED",
  suggestedByAI: "suggestedByAI",
  mandatory: "MANDATORY"
};
